export default {"src":"/_next/static/media/angle-down.6003d83a.svg","height":32,"width":32};